import { API } from '@ospace/shared'

const createObjectiveResult = async (objective: any) => {
  return await API.post('client', `/objectives/results`, {
    body: objective,
  })
}

export const ObjectiveService = {
  createObjectiveResult,
}
